const layoutConfig = {
    sidebar: {
        // open: false, //if true then sidebar will be expanded otherwise collapsed
        hide: true,
    },
    content: {
        sx: {
            p: 0,
            px: {lg: 0, xs: 0}
        }
    },
    header: {
        hide: false,
    },
    footer: {
        hide: false,
    }
};

export default layoutConfig;